import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React, { useCallback, useMemo } from 'react';
import parseFare from 'common/utils/parse-fare';
import { cumulateFare, displayCumulatedFare } from 'common/utils/cumulate-fare';
import _get from 'lodash/get';
import NewBookingDuck from 'ducks/new-booking-duck';
import NewBulkUploadDuck from 'ducks/new-bulk-upload-duck';
import ServiceTypeSectionUI from '../common-section-ui/service-type-section-ui';
import generateServiceTypesToRender from '../common-logic/service-type';

const BulkServiceTypeSection = ({
  dispatch,
  selectedServiceTypeKey,
  deliveryIDs,
  deliveries,
  countryCode,
}) => {
  const onServiceTypeClick = useCallback(
    ({ serviceType, specialServiceType }) => {
      dispatch(
        NewBookingDuck.creators.bulkUpdateServiceConfig(deliveryIDs, {
          serviceType,
          specialServiceType,
        }),
      );
      dispatch(NewBulkUploadDuck.creators.trySetOfferConfig(null));
    },
    [dispatch, deliveryIDs],
  );

  const serviceTypesToRender = useMemo(
    () => {
      const availableServices = {};
      const cumulatedFares = {};
      deliveries.forEach(delivery => {
        const serviceTypes = _get(delivery, 'config.serviceTypes', []);
        const dropOffs = _get(delivery, 'detail.dropOffs', []);
        const serviceTypesToRender = generateServiceTypesToRender(
          serviceTypes,
          dropOffs,
          countryCode,
        );
        serviceTypesToRender.forEach(st => {
          if (!availableServices[st.key]) {
            availableServices[st.key] = st;
          }
          const parsedFare = parseFare(st.fare);
          cumulateFare(cumulatedFares, st.key, parsedFare);
          availableServices[st.key].disabled =
            availableServices[st.key].disabled || st.disabled;
          if (
            !availableServices[st.key].disabledHint ||
            !availableServices[st.key].disabledReason
          ) {
            availableServices[st.key].disabledHint = st.disabledHint;
            availableServices[st.key].disabledReason = st.disabledReason;
          }
        });
      });

      Object.values(availableServices).forEach(st => {
        st.fare = displayCumulatedFare(cumulatedFares[st.key]);
      });
      return Object.values(availableServices);
    },
    [deliveries, countryCode],
  );

  return (
    <ServiceTypeSectionUI
      onServiceTypeClick={onServiceTypeClick}
      selectedServiceTypeKey={selectedServiceTypeKey}
      serviceTypesToRender={serviceTypesToRender}
    />
  );
};

BulkServiceTypeSection.defaultProps = {
  selectedServiceTypeKey: undefined,
};

BulkServiceTypeSection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedServiceTypeKey: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  deliveryIDs: PropTypes.arrayOf(PropTypes.string).isRequired,
  deliveries: PropTypes.arrayOf(NewBookingDeliveryPropType).isRequired,
};

export default BulkServiceTypeSection;
